
import { getStudentDetail } from '../../services/api'
import notifications from '../notifications.js'

async function _getStudentDetail(studentDbId) {
  try {
    let response = await getStudentDetail(studentDbId)
    return response.data
  }
  catch (error) {
    notifications.pushError('Unable to load student detail info.', error)
  }
}

export default {
  getStudentDetail: _getStudentDetail,
}
